<button type="button" class="conflict-indicator" [class]="color()" [disabled]="disabled()">
  <span class="conflict-indicator-label">{{ label() }}</span>
  <span class="conflict-indicator-count">{{ count() }}</span>
</button>
